// utils/auth.js
export function clearTokenAndRedirect() {

  sessionStorage.removeItem('token');

  const currentUrl = window.location.href;
  const urlObj = new URL(currentUrl);
  urlObj.searchParams.delete('token');

  let finalUrl;
  const hash = urlObj.hash;

  if (/^#\/activityInfo\/\d+$/.test(hash)) {
    finalUrl = urlObj.toString();
  } else {
    urlObj.search = '';
    urlObj.hash = '';
    finalUrl = urlObj.origin;
  }
  const redirectUrl = encodeURIComponent(finalUrl);
  window.location.href = `${process.env.REACT_APP_PROXY_TARGET_URL}?redirect_url=${redirectUrl}`;
}
